import { LANG_CODE, LOCALE_CODE } from "@/constants/locale"
import { useStore } from "./store"
import { querySet } from "./url"

export const lang = querySet.lang || LANG_CODE.ES_MX
export const locale = querySet.locale || LOCALE_CODE.ES_MX

/**
 * 更新lang到store
 * 更新mand-mobile组件默认文案
 */
export const updateLangInfo = () => {
  useStore().commit('common/update', {
    lang,
    locale,
  })
}

/**
 * 处理翻译文案 {{brand_name}} -> {brand_name}
 * vue-i18n只支持单括号替换变量
 * @wiki 更多占位符请参考文案翻译中心wiki: http://i18n.xiaojukeji.com/help/copy-standard
 */
const format = (val: string) => {
  return val.replace(/\{\{(\s*\w+\s*)\}\}/g, `{$1}`)
}

/**
 * 将{{param}}转换成vue-i18n接受的变量模式
 * @param rawObj 翻译文案的obj
 * @param ns 命名空间
 * @returns object
 * @example {{param}} => {param}
 */
export const transfromAll = (
  target: Record<string, any> | string
): any => {
  if (typeof target === 'object') {
    const cloneTarget = {}
    for (const key in target as Record<string, string>) {
      Object.assign(cloneTarget, {
        [key]: transfromAll(target[key]),
      })
    }
    return cloneTarget
  } else {
    return format(target as string)
  }
}
